import $ from "jquery";
import "./lib/foundation";
import "@ijuice/cookie-disclaimer";

const ANIMATION_TIME    = 1000,
      FORWARD           = -1,
      BACKWARD          = 1,
      REQUIRED          = 1,
      NOT_THERE         = -1,
      ANIMATION_PADDING = 25;
let currentStep         = $("#sell-form-step-1");

$(document).foundation();

/**
 * Scroll to the element with the id
 *
 * @param id
 */
function scrollTo(id) {
  $("html, body").animate({
    scrollTop: $(id).offset().top,
  }, ANIMATION_TIME);
}

/**
 * Removes all previously added error-messages
 *
 * @param label - label containing the input
 */
function cleanValidation(label) {
  label.removeClass("error");
  label.find(".missing-error").hide();
  label.find(".validation-error").hide();
}

/**
 * Add error to display
 *
 * @param label
 * @param type
 * @param errorMessage
 */
function addError(label, type = "missing-error", errorMessage = "") {
  label.addClass("error");
  label.find(`.${type}`).show();
  if(errorMessage !== "") {
    label.find(`.${type}`).text(errorMessage);
  }
}

/**
 * Validates an input. Adds error-messages as necessary. Returns true if valid and false if invalid
 *
 * @param inputRef - Reference of the input. Should be understandable for jQuery
 * @param value - value of the input
 * @returns {boolean}
 */
function validateInput(inputRef, value) {
  let ok            = true;
  const input       = $(inputRef),
        label         = $(`label[for="${input.attr("id")}"]`).length > 0 ? $(`label[for="${input.attr("id")}"]`) : input.parent("label"),
        isToBeChecked = ["checkbox", "radio"].indexOf(input.prop("type")) > NOT_THERE;
  cleanValidation(label);

  if(parseInt(input.data("required"), 10) === REQUIRED && ((!isToBeChecked && value === "") || (isToBeChecked && !input.is(":checked")))) {
    addError(label, "missing-error");
    ok = false;
  }

  const validators = input.data("validators");
  for(const key in validators) {
    if(!Object.prototype.hasOwnProperty.call(validators, key)) {
      continue;
    }
    const validator = validators[key],
          fn        = window[validator.javascript_validator];
    if(!fn(value) && value !== "") {
      addError(label, "validation-error", validator.error_message);
      ok = false;
    }
  }
  return ok;
}

/**
 * validates Files for size and count
 *
 * @param container
 * @returns {boolean}
 */
function validateFiles(container) {
  let cFiles    = 0,
      sizeFiles = 0,
      ok        = true;
  $(container).find(".upload-errors")
    .empty();
  $(container).find(".js-upload-button")
    .each(function collectAllFiles(_, input) {
      for(const i in input.files) {
        if(!Object.prototype.hasOwnProperty.call(input.files, i)) {
          continue;
        }
        cFiles++;
        sizeFiles += input.files[i].size;
        if(input.files[i].size > $(".upload-btn-wrapper").data("max-size-single")) {
          $(container).find(".upload-errors")
            .append(`<small>Datei '${input.files[i].name}' ist zu groß!</small>`);
          ok = false;
        }
      }
    });
  if(cFiles > $(".upload-btn-wrapper").data("max-count")) {
    $(container).find(".upload-errors")
      .append("<small>Zu viele Dateien!</small>");
    ok = false;
  }
  if(sizeFiles > $(".upload-btn-wrapper").data("max-size-total")) {
    $(container).find(".upload-errors")
      .append("<small>Dateien sind insgesamt zu groß!</small>");
    ok = false;
  }
  return ok;
}

/**
 * Validates all inputs and selects within the given container.
 *
 * @param container
 * @returns {boolean}
 */
function validateForm(container) {
  const inputs  = $(container).find("input"),
        selects = $(container).find("select");
  let ok        = true;
  inputs.each(function validate(i, input) {
    ok = validateInput(input, $(input).val()) && ok;
  });
  selects.each(function validate(i, input) {
    ok = validateInput(input, $(input).find(":selected")
      .val()) && ok;
  });
  ok = validateFiles(container) && ok;
  return ok;
}

/**
 * returns true if given string is an email
 *
 * @param email
 * @returns {boolean}
 */
window.validateEmail = function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

/**
 * Slides the target step in.
 *
 * @param id - html-id of the target step
 * @param direction - direction to slide into: FORWARD or BACKWARD
 */
function moveToStep(id, direction = FORWARD) {
  const targetStep      = $(`#${id}`),
        formOffset      = -$(".sell-form").width() * direction,
        directedPadding = ANIMATION_PADDING * direction;
  if(targetStep === currentStep || (direction === FORWARD && !validateForm(currentStep))) {
    return;
  }
  let add = 0;
  if(direction === BACKWARD) {
    add = $(".sell-form").width();
  }
  scrollTo("#form-top");

  currentStep.css("right", `${add}px`)
    .animate({
      right: formOffset - directedPadding + add,
    }, ANIMATION_TIME, function hidePrevious() {
      $(this).hide();
    });

  targetStep
    .css("right", `${directedPadding + add}px`)
    .show()
    .animate({
      right: formOffset + add,
    }, ANIMATION_TIME, function displayCurrent() {
      currentStep.show().css("right", "0px");
    });

  currentStep = targetStep;
}

$(".sell-form-container, .missing-error, .validation-error").hide();
currentStep.show();

$("#to-sell-form-step-2").on("click", function moveToStep2() {
  moveToStep("sell-form-step-2");
});
$("#to-sell-form-step-3").on("click", function moveToStep3() {
  moveToStep("sell-form-step-3");
});
$("#to-sell-form-step-4").on("click", function moveToStep4() {
  moveToStep("sell-form-step-4");
});

$("#back-to-sell-form-step-1").on("click", function moveToStep1() {
  moveToStep("sell-form-step-1", BACKWARD);
});
$("#back-to-sell-form-step-2").on("click", function moveToStep2() {
  moveToStep("sell-form-step-2", BACKWARD);
});
$("#back-to-sell-form-step-3").on("click", function moveToStep3() {
  moveToStep("sell-form-step-3", BACKWARD);
});

$(".sell-form input[type!='file'], .sell-form select").on("change", function dublicateToFieldsOfSameName() {
  $(`.sell-form [name="${$(this).attr("name")}"]`).val($(this).val());
});
$(".loading").hide();

$(".sell-form").on("submit", function sendFormWithAjax(e) {
  e.preventDefault();
  if(validateForm($(this))) {
    $(".sell-form").find("input")
      .prop("disable", true);
    $(".loading").show();
    const formData = new FormData(this);
    $.ajax({
      url        : "/send.php",
      type       : "POST",
      data       : formData,
      processData: false,
      contentType: false,
      error() {
        $(".sell-form").find("input")
          .prop("disable", false);
        $(".loading").hide();
        alert("Es ist ein Fehler beim Versenden des Formulars aufgetreten.");  // eslint-disable-line no-alert
      },
      success: function success(data) {
        $(".sell-form").find("input")
          .prop("disable", false);
        $(".loading").hide();
        const json = JSON.parse(data);
        if(json.status === "ok") {
          moveToStep("sell-form-success");
        } else {
          let firstParent = null;
          for(const fieldName in json.errors) {
            if(!Object.prototype.hasOwnProperty.call(json.errors, fieldName)) {
              continue;
            }
            const field = $(`name=["${fieldName}"]`);
            addError(field.parent("label"), "validation-error", json.errors[fieldName]);
            if(firstParent === null || $(".sell-form-container").index(firstParent) > $(".sell-form-container").index(field.parent(".sell-form-container"))) {
              firstParent = field.parent(".sell-form-container");
            }
          }
          moveToStep(firstParent, BACKWARD);
        }
      },
    });
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/app.js